export default {
  node: '/api',
  nodeExport: '/node-export',
  api: process.env.REACT_APP_PRESCRIPTION_API,
  medData: process.env.REACT_APP_MED_DATA,
  passportAPI: process.env.REACT_APP_PASSPORT_API,
  cloudPharmacyInterface: process.env.REACT_APP_CLOUD_PHARMACY_INTERFACE,
  medicationAPI: process.env.REACT_APP_API_URL_MEDICATION,
}
